export default "__VITE_ASSET__C9ZdDw6r__"